import { defineComponent } from 'vue'
import NoAuth from '~/layouts/NoAuth.vue'
import AuthBlank from '~/layouts/AuthBlank.vue'

export enum Layouts {
  NO_AUTH = 'NoAuth',
  AUTH_BLANK = 'AuthBlank',
}

export const LayoutComponents: Record<Layouts, ReturnType<typeof defineComponent>> = {
  [Layouts.NO_AUTH]: NoAuth,
  [Layouts.AUTH_BLANK]: AuthBlank,
}
